import NodeModel from 'rise-ui/models/types/node.js';

import { attr } from '@ember-data/model';

export default class AnnouncementModel extends NodeModel {
  @attr('string') uuid;
  @attr('string') title;
  @attr('string') contentType;
  @attr image;
  @attr('date') announcementDate;
}
